/*
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */


app.controller('RecipientEdit', function($scope, $stateParams, recipientService, $rootScope, $q,
    $http, _$editmode) {

    _$editmode.turnOn();

    $scope.printAfterSave = 0;

    $scope.tab = {
        title: "Edycja odbiorcy",
        type: "edit"
    };

    $scope.data = {
        "id": $stateParams.id,
        "states": [],
        "filters": []
    };


    $scope.autocompletes = {
        "city": {
            //"required": true,
            "name": ""
        },
        "comunity": {
            //"required": true,
            "name": ""
        },
        "county": {
            //"required": true,
            "name": ""
        },
        "street": {
            "name": ""
        },
        "loaded": false
    };

    $scope.row = [];

    /*
     * save
     */

    $scope.checkRecipient = function(form) {
        if (form.$valid) {
            return true;
        } else {
            angular.forEach(form.$error, function(field) {
                angular.forEach(field, function(f) {
                    f.$setDirty();
                    f.$setTouched();
                });
            });
            $rootScope.notification.show('error', 'Formularz nie został prawidłowo wypełniony');
            return false;
        }
    };

    $scope.saveRecipient = function(form) {
        var params = angular.copy($scope.row);
        params.data.birthdate = $rootScope.formatDate(params.data.birthdate);

        params.address.city = typeof $scope.autocompletes.city == "object" && $scope.autocompletes.city != null ? $scope.autocompletes.city.name : "";
        params.address.county = typeof $scope.autocompletes.county == "object" && $scope.autocompletes.county != null ? $scope.autocompletes.county.name : "";
        params.address.county_id = typeof $scope.autocompletes.county == "object" && $scope.autocompletes.county != null ? $scope.autocompletes.county.county_id : "";
        params.address.comunity = typeof $scope.autocompletes.comunity == "object" && $scope.autocompletes.comunity != null ? $scope.autocompletes.comunity.name : "";
        params.address.comunity_id = typeof $scope.autocompletes.comunity == "object" && $scope.autocompletes.comunity != null ? $scope.autocompletes.comunity.comunity_id : "";
        params.address.street = typeof $scope.autocompletes.street == "object" && $scope.autocompletes.street != null ? $scope.autocompletes.street.name : "";

        if(params.address.comunity.indexOf('(')!=-1){
          params.address.comunity = params.address.comunity.substring(0,params.address.comunity.indexOf('(')).trim();
        }

        var promise = recipientService.update($scope.data.id, params);
        promise.then(
            function(payload) {
                if (payload.data.code == 1) {
                    if ($scope.printAfterSave) {
                        setTimeout(function() {
                            $scope.printAfterSave = 0;
                            var promise = recipientService.printpdf($scope.data.id);
                            promise.then(function(payload) {
                                top.location.href = "/downloadpdf/" + payload.data;
                            });
                        }, 1000);
                    }

                    $rootScope.notification.showAfterRedirect('recipient', {
                        id: $scope.data.id
                    }, 'success', payload.data.msg);
                } else {
                    $rootScope.notification.show('error', payload.data.msg);
                }
            },
            function(errorPayload) {
                $rootScope.notification.show('error', 'Błąd edycji odbiorcy');
            });
    };

    $scope.saveWithPrint = function(form) {
        $scope.printAfterSave = 1;
        $scope.saveRecipient(form);
    }

    $scope.init = function() {
        var promise = recipientService.edit($scope.data.id);
        promise.then(
            function(payload) {
                if (payload.data.row.length == 0) {
                    $rootScope.notification.showAfterRedirect('recipients', {}, 'error', 'Podany odbiorca nie został odnaleziony');
                } else {
                    $scope.row = payload.data.row;
                    $scope.row.info = {
                        "active": $scope.row.active,
                        "spamer": $scope.row.spamer,
                        "verified": $scope.row.verified,
                        "mobile_verification_code": $scope.row.mobile_verification_code
                    };

                    $scope.autocompletes.county = {
                        "disabled": false,
                        "name": ($scope.row.address.county == null ? "" : $scope.row.address.county),
                        "county_id": ($scope.row.address.county_id == null ? "" : $scope.row.address.county_id)
                    };
                    $scope.autocompletes.comunity = {
                        "disabled": false,
                        "name": ($scope.row.address.comunity == null ? "" : $scope.row.address.comunity),
                        "comunity_id": ($scope.row.address.comunity_id == null ? "" : $scope.row.address.comunity_id)
                    };
                    $scope.autocompletes.city = {
                        "disabled": false,
                        "name": ($scope.row.address.city == null ? "" : $scope.row.address.city)
                    };
                    $scope.autocompletes.street = {
                        "disabled": false,
                        "name": ($scope.row.address.street == null ? "" : $scope.row.address.street)
                    };

                    $scope.autocompletes.loaded = true;

                    $scope.subunitSupported = payload.data.subunitSupported;
                    $scope.teamSupported = payload.data.teamSupported;

                    $scope.row.data.birthdate = $rootScope.formatDate($scope.row.data.birthdate);
                    $rootScope.filters = payload.data.filters;
                }
            },
            function(errorPayload) {
                $rootScope.notification.show('error', 'Błąd edycji odbiorcy');
            });
    };

    $scope.init();

});
